import { render } from "./DepositRequestRejected.vue?vue&type=template&id=24ac9650"
import script from "./DepositRequestRejected.vue?vue&type=script&lang=js"
export * from "./DepositRequestRejected.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__